export const REPORTING_SUCCESS = "REPORTING_SUCCESS";
export const REPORTING_LOADING = "REPORTING_LOADING";
